import { render } from "./page-2.7.vue?vue&type=template&id=64abada2&scoped=true"
import script from "./page-2.7.vue?vue&type=script&lang=js"
export * from "./page-2.7.vue?vue&type=script&lang=js"

import "./page-2.7.vue?vue&type=style&index=0&id=64abada2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64abada2"]])

export default __exports__